/* eslint-disable react/forbid-prop-types */
/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import FaCheck from 'react-icons/lib/fa/check';
import FaAsterisk from 'react-icons/lib/fa/asterisk';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';
import Collapsible from '../../Collapsible';

import s from './Features.scss';
import collapsibleStyles from '../../Collapsible/Collapsible.scss';

const messages = defineMessages({
  showDetails: {
    id: 'pricing.showDetails',
    defaultMessage: 'Show details',
    description:
      'Label to show license package details link on product pricing',
  },
  hideDetails: {
    id: 'pricing.hideDetails',
    defaultMessage: 'Hide details',
    description:
      'Label to hide license package details link on product pricing',
  },
});

class Features extends React.Component {
  static propTypes = {
    featureHeaderText: PropTypes.object,
    featureList: PropTypes.array.isRequired,
    notesList: PropTypes.array,
    collapsible: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    collapsible: false,
    featureHeaderText: null,
    notesList: null,
  };

  constructor(props) {
    super(props);

    this.renderFeature = this.renderFeature.bind(this);
    this.renderFeatureHeaderText = this.renderFeatureHeaderText.bind(this);
  }

  renderFeatureHeaderText() {
    const { featureHeaderText } = this.props;

    if (featureHeaderText) {
      return (
        <li key={featureHeaderText.id}>
          <i>
            <FaCheck />
          </i>
          <strong style={{ fontSize: '1rem' }}>
            <FormattedMessage {...featureHeaderText} />
          </strong>
        </li>
      );
    }
    return <li />;
  }

  // eslint-disable-next-line class-methods-use-this
  renderFeature(feature) {
    return (
      <li key={feature.id}>
        <i>
          <FaCheck />
        </i>
        <FormattedMessage {...feature} />
      </li>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  renderNote(note) {
    return (
      <li key={note.id}>
        <i>
          <FaAsterisk />
        </i>
        <FormattedMessage {...note} />
      </li>
    );
  }

  render() {
    const { featureList, notesList, collapsible } = this.props;
    const renderedFeatures = featureList.map(this.renderFeature);
    const renderedNotes = notesList ? notesList.map(this.renderNote) : null;

    if (collapsible) {
      return (
        <div className={cx('visible-xs', collapsibleStyles.collapsibleDetails)}>
          <Collapsible
            heading={this.props.intl.formatMessage(messages.showDetails)}
            headingWhenOpened={this.props.intl.formatMessage(
              messages.hideDetails,
            )}
          >
            <ul className={s.licenseBenefits}>
              {this.renderFeatureHeaderText(this.props.featureHeaderText)}
              {renderedFeatures}
              {renderedNotes}
            </ul>
          </Collapsible>
        </div>
      );
    }

    return (
      <ul className={cx('hidden-xs', s.licenseBenefits)}>
        {this.renderFeatureHeaderText()}
        {renderedFeatures}
        {renderedNotes}
      </ul>
    );
  }
}

export default injectIntl(withStyles(s, collapsibleStyles)(Features));



// WEBPACK FOOTER //
// ./src/components/ProductPage/Features/index.js